module.exports = __webpack_public_path__ + "static/media/15.d4063949.png";